import {AxiosResponse} from 'axios';
//api
import {userAPI} from '@/core/api';
//types
import {IUserOrganizationSettingData} from '@/utils/types';
//enum
import {API_URL} from '../enums/api-url.enum';

class UserNotificationSettingService {
	static getAllNotificationSetting = async (userId: number): Promise<AxiosResponse<IUserOrganizationSettingData>> =>
		userAPI.get(`${API_URL.USER_NOTIFICATION_SETTING}/${userId}`);

	static updateNotificationSetting = async (
		userId: number,
		reqBody: IUserOrganizationSettingData
	): Promise<AxiosResponse<IUserOrganizationSettingData>> =>
		userAPI.put(`${API_URL.USER_NOTIFICATION_SETTING}/${userId}`, reqBody);
}

export {UserNotificationSettingService};
